"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var theme_1 = __importDefault(require("../../../styles/theme"));
var makeStyles_1 = __importDefault(require("../../../util/makeStyles"));
var styleUtilities_1 = require("../../../util/styleUtilities");
exports.default = (0, makeStyles_1.default)(function () {
    return (0, styles_1.createStyles)({
        root: __assign(__assign({ height: 28, borderRadius: 16, padding: '0 4px', display: 'flex', width: 'fit-content', maxWidth: '100%', overflowWrap: 'anywhere', overflow: 'hidden' }, theme_1.default.fonts.body), { color: theme_1.default.textColors.highlight, backgroundColor: "".concat((0, styleUtilities_1.withOpacity)(theme_1.default.colors.primaryLight, 0.5), " !important") }),
        label: {
            padding: '0 4px',
        },
        icon: { margin: 0, paddingRight: 4 },
        deleteIcon: {
            margin: 0,
        },
    });
});
